<template>
<div ref="pay-card-otp" id="pay-card-otp" class="opt-content-wrapper pay-pane active py-0 px-0">
    <div class="modal-body pb-1">
        <div class="row mx-0">
            <!-- div class="options-list text-center px-2" -->
            <div class="options-list text-center">

                <h5 v-if="template === 'two'" :style="{color: client_info.colors.payment_description + '!important'}" class="my-0">Select Payment Method</h5>

                <ul id="itemList" class="mx-0 px-0 itemList v2-flex-container mb-4" :style="data.channels.length > 4 ? '{ flex-wrap: wrap }' : ''">
                    <li @mouseover="hoverEffect(true, key)" @mouseleave="hoverEffect(false, key)" @click="changeComponent(item.auth_type, key)" :id="'list-'+key" class="app-text-color fade fg-1" v-for="(item, key) in initialItems" :key="key" :style="option_item_hover">

                        <img v-if="client_info.show_options_icon" :src="item.image_url || '/img/'+item.auth_type.toLowerCase()+'.svg'" alt="" />

                        <p v-if="template === 'one'" :style="{ 'color' : `${(listHover && !hoverKey) ? client_info.colors.list_hover_item +'!important' : ''}`}" class="title" v-html="(title_prefix ? title_prefix + ' ' : '') + item.title"></p>
                        <p v-else :style="{ 'color' : `${(listHover && !hoverKey) ? client_info.colors.list_hover_item +'!important' : ''}`}" class="title" v-html="item.title"></p>
                    </li>
                </ul>

                <div v-if="showPagination">
                    <a @mouseover="hover = true " @mouseleave="hover =false" href="javascript:void(0)" :style="hover ? paginate_hover_in_style : ''" v-if="totalShown < data.channels.length" class="show-more mt-3" @click.prevent="showMore"> More ways to pay</a>

                    <a @mouseover="hover = true " @mouseleave="hover =false" href="javascript:void(0)" :style="hover ?  paginate_hover_in_style : ''" v-if="totalShown >= data.channels.length" class="show-more mt-3" @click.prevent="showLess"> Show Less</a>
                </div>

            </div>

            <div class="col-12 px-0 mt-4">
                <div v-if="!loading" class="mb-0 text-center">
                    <a href="javascript:void(0)" class="change-option" @click.prevent="reload" title="Fetch payment methods again"> &#x21bb; Refresh </a>
                </div>
            </div>

        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'payment-options',
    props: {
        data: Object,
        client_info: Object,
        title_prefix: String,
        template: {
            type: String,
            default: 'default'
        }
    },

    computed: {
        // this.client_info.paginate_count
        option_list() {
            // show_more
            // return data.channels.slice(0, this.client_info.paginate_count || 5);
            return this.data.channels.filter((item) => {
                item.auth_type.toLowerCase() == 'card' || (item.action && item.action.length > 0)
            });
        }
    },
    data() {
        return {
            trx_otp: '',
            otp_error_message: '',
            // client_info: {},
            isFocus: true,
            focusColor: '',
            totalShown: 0,
            perPage: 0,
            halfList: [],
            showNum: true,
            hover: false,
            listHover: false,
            hoverKey: '',
            paginate_hover_in_style: {},
            paginate_hover_out_style: {},
            option_item_hover: {},
            loading: false,
            showPagination: false,
            show_more: false,
            errors: {
                trx_otp: false,
            },
            initialItems: [],
        }
    },

    async mounted() {

        try {

            this.perPage = this.client_info.paginate_count;
            this.paginate_hover_out_style = '';
            this.paginate_hover_in_style = {
                background: this.client_info.colors.app,
                color: '#ffffff'
            };

            let key;

            this.option_item_hover = {
                background: (this.listHover && this.hoverKey == key) ? this.client_info.colors.list_hover_background + '!important' : '',
                color: (this.listHover && this.hoverKey == key) ? this.client_info.colors.list_arrow_hover || this.client_info.colors.app : this.client_info.colors.list_arrow || this.client_info.colors.app
            };

            // Check if default view is present
            if (this.$store.state.showDefaultView) {
                let defaultView = await this.$parent.hasDefaultView();
                if (defaultView && defaultView.status) {
                    this.changeComponent(defaultView.auth_type, defaultView.key, true, defaultView.provider_key, );
                    return;
                } else {
                    this.defaultListings();
                }
            } else if (this.data.channels.length == 1) {
                this.changeComponent(this.data.channels[0].auth_type, 0)
            } else {
                this.defaultListings();
            }
        } catch (err) {
            console.log(err);
        }
    },

    methods: {
        defaultListings() {
            if (this.client_info.paginate === true) {
                this.showPagination = this.data.channels.length > this.client_info.paginate_count ? true : false;
                this.perPage = this.client_info.paginate_count;
                this.totalShown = this.perPage
                this.initialItems = this.data.channels.slice(0, this.client_info.paginate_count);
            } else {
                this.initialItems = this.data.channels;
            }
        },
        hoverEffect(value, key) {
            this.listHover = value
            this.hoverKey = key
        },

        showMore() {
            // let itemList = document.getElementById('itemList');
            // height = itemList.offsetHeight;

            setTimeout(() => {
                this.initialItems = this.data.channels;
                this.totalShown = this.initialItems.length;
            }, 100)
        },

        showLess() {
            this.initialItems = this.data.channels.slice(0, this.client_info.paginate_count);
            this.totalShown = this.initialItems.length;
        },

        changeComponent(method, index, defaultView = false, provider_key = 0) {

            try {

                let data = this.data.channels[index];

                this.$store.dispatch('paymentMethod', method)
                this.$store.dispatch('paymentMethodIndex', index)
                this.$store.dispatch('paymentMethodProvider', method.toLowerCase())
                // this.$store.dispatch('provider', data);

                let componentId = "";
                // activeName = "";
                let transaction;
                let redirectData;

                // Keep Payment Option
                // console.log(method);
                switch (method.toLowerCase()) {
                    case "airtime":
                        componentId = "Airtime";
                        // activeName = "Airtime";

                        // watchout for comin soon.
                        break;

                    case "wallet":
                        componentId = "Airtime";
                        // activeName = "wallet";
                        break;

                    case "bank.account":
                        componentId = "Airtime";
                        // activeName = "account";
                        break;

                    case "voucher":
                        componentId = "Airtime";
                        // activeName = "voucher";
                        break;

                    case "bank.transfer":
                        componentId = "Transfer";
                        // activeName = "Transfer";
                        break;

                    case "cash":
                        componentId = "Transfer";
                        // activeName = "cash";
                        break;

                    case "masterpass":
                    case "ipg":
                    case "paystack":
                    case "custom":

                        if (this.data.channels[index].action.length == 1) {
                            let provider = this.data.channels[index].action[0].provider.toLowerCase();

                            switch (provider) { //For the New changes
                                case 'mpgs':
                                    componentId = "CardPayment";
                                    break;

                                case 'comingsoon':
                                    componentId = "ComingSoon";
                                    this.$parent.changeComponent(componentId, this.data.channels[index].action[0]);
                                    return;
                                default:
                                    // Do a second level check using providers or check if the have urls then you load the urls or the relevant pages 
                                    componentId = "Redirect";
                                    // Build User information or data and pass as props
                                    transaction = this.$store.state.payload.transaction;
                                    redirectData = {
                                        'channels': this.data.channels,
                                        // 'details': data.action[0],
                                        'index': index,
                                        'transaction': transaction
                                    }

                                    if (data.action.length > 1) {
                                        if (data.action.length > 1 && defaultView) {
                                            redirectData.details = data.action[provider_key]
                                            redirectData.action = data.action;
                                            redirectData.custom_providers = data.action;
                                        } else {
                                            redirectData.action = data.action;
                                            redirectData.custom_providers = data.action;
                                        }
                                    } else {
                                        redirectData.details = data.action[0]
                                    }

                                    data = redirectData;
                                    break;
                            }

                        } else {
                            // Do a second level check using providers or check if the have urls then you load the urls or the relevant pages 
                            componentId = "Redirect";
                            // Build User information or data and pass as props
                            transaction = this.$store.state.payload.transaction
                            redirectData = {
                                'channels': this.data.channels,
                                // 'details': data.action[0],
                                'index': index,
                                'transaction': transaction
                            }

                            if (data.action.length > 1) {
                                if (data.action.length > 1 && defaultView) {
                                    redirectData.details = data.action[provider_key]
                                    redirectData.action = data.action;
                                    redirectData.custom_providers = data.action;
                                } else {
                                    redirectData.action = data.action;
                                    redirectData.custom_providers = data.action;
                                }
                            } else {
                                redirectData.details = data.action[0]
                            }

                            data = redirectData;
                        }
                        break;

                    default:
                    case "card":
                        // case "mpgs":
                        componentId = "CardPayment";
                }

                this.$parent.changeComponent(componentId, data);
            } catch (err) {
                console.log(err);
            }
        },
        reload() {
            // Hit the Options api again
            this.$parent.reload();
        }
    }
};
</script>

<style scoped>
.v2-flex-container {
    display: flex !important;
    flex-flow: column wrap;
    transition: all .5s ease-in-out;
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
    border: solid 1px #ccc;
    border-radius: 5px;
    border-bottom: none;
    /* filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.6)); */
    webkit-box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.2);
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.2);

}

ul.v2-flex-container li {
    list-style-type: none;
    height: 40px;
    cursor: pointer;
    background: #f5f5f578;
    font-size: 12px;
    padding: 8px 0px 8px 0px;
    width: 100%;
    border-bottom: #ded8d8 solid 1px;
    line-height: 40px;
    text-align: left;
}

/* border-radius: 5px 5px 0px 0px; */

ul.v2-flex-container li:first-child {
    border-radius: 5px 5px 0px 0px
}

ul.v2-flex-container li:last-child {
    /* border-bottom: none; */
    border-radius: 0px 0px 5px 5px;
}

ul.v2-flex-container li:hover,
ul.v2-flex-container li:focus {
    background: #e4e4e4;
    color: #000000 !important;
    margin-right: 30px;
}

ul.v2-flex-container li>p:hover,
ul.v2-flex-container li>p:focus {
    color: #000000;
}

ul.v2-flex-container li img {
    height: 30px;
    width: 30px;
    line-height: 30px;
    padding-left: 15px;
    margin-right: 10px;
    vertical-align: middle;
}

.options-list ul li p {
    font-weight: 600;
    vertical-align: middle;
    margin: 0%;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    text-align: left;
}

ul.v2-flex-container li::after {
    content: "\203A";
    font-weight: 300;
    font-size: 25px;
    float: right;
    margin-right: 15px;
}
</style>
